import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmTextFieldTracking() {
  useEffect(() => {
    const handleBlur = (e: FocusEvent) => {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }
      if (!['text', 'email', 'tel', 'url', 'search', 'password'].includes(e.target.type)) {
        return;
      }

      const label = findAssociatedLabel(e.target);
      triggerGoogleTagManagerCustomEvent(GtmEvents.TEXTFIELD_INPUT, {
        label,
        length: e.target.value.length,
      });
    };

    document.addEventListener('focusout', handleBlur, { capture: true });
    return () => {
      document.removeEventListener('focusout', handleBlur, { capture: true });
    };
  }, []);
}

export default useGtmTextFieldTracking;
